import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Form, Input, message, Row, Select } from 'antd';
import { BackBtn } from '@comm/BackBtn';
import { Link } from 'react-router';

import { getCustomInvoiceTodo } from '@store/modules/incubator/invoice/invoice_todo_list';
import { queryInvoiceInvalid } from '@api/incubator/invoice';
import ModalInvalid from './ModalInvalid';
import TableCustomStatic from './TableCustomStatic';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      condition: '',
    };
  }

  componentDidMount() {
    this.getCustomInvoiceTodo();

    const {
      data: {
        list,
        pagination: { current = 1 },
      },
    } = this.props;
    this.current = current;
    const hiddenInvoiceList = list.filter(item => item.availableInvoice !== 0);
    const hiddenReceiptList = list.filter(item => item.availableReceipt !== 0);
    const hiddenBothList = list.filter(
      item => item.availableInvoice !== 0 && item.availableReceipt !== 0,
    );
    this.setState({
      showList: list,
      allList: list,
      hiddenInvoiceList,
      hiddenReceiptList,
      hiddenBothList,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.list !== nextProps.data.list) {
      const {
        data: {
          list,
          pagination: { current = 1 },
        },
      } = nextProps;
      this.current = current;
      const hiddenInvoiceList = list.filter(item => item.availableInvoice !== 0);
      const hiddenReceiptList = list.filter(item => item.availableReceipt !== 0);
      const hiddenBothList = list.filter(
        item => item.availableInvoice !== 0 && item.availableReceipt !== 0,
      );
      this.setState({
        showList: list,
        allList: list,
        hiddenInvoiceList,
        hiddenReceiptList,
        hiddenBothList,
      });
    }
  }

  handleTableChange = pagination => {
    this.getCustomInvoiceTodo();
  };

  getCustomInvoiceTodo = () => {
    this.props.dispatch(
      getCustomInvoiceTodo({
        incubatorUuid: this.props.params.uuid,
        start: this.current || 1,
        limit: 1000,
        condition: this.state.condition,
      }),
    );
  };

  invalidInvoice = params => {
    queryInvoiceInvalid(params).then(res => {
      if (res.statusCode === 200) {
        this.getCustomInvoiceTodo();
        this.handleVisible(false);
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  onSearch = params => {
    console.log('params:', params);
    this.setState(
      {
        condition: params.condition,
      },
      () => {
        this.getCustomInvoiceTodo();
      },
    );
  };

  changeHidden = value => {
    const { hiddenInvoiceList, hiddenReceiptList, hiddenBothList, allList } = this.state;
    switch (value) {
      case 'hiddenInvoice':
        this.setState({
          showList: hiddenInvoiceList,
        });
        break;
      case 'hiddenReceipt':
        this.setState({
          showList: hiddenReceiptList,
        });
        break;
      case 'hiddenBoth':
        this.setState({
          showList: hiddenBothList,
        });
        break;
      default:
        this.setState({
          showList: allList,
        });
    }
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  onReset = () => {
    const params = {};
    params.condition = '';
    this.onSearch(params);
    this.props.form.resetFields();
  };

  render() {
    const { visible, showList } = this.state;
    const { form, loading, accountInfo } = this.props;
    const { getFieldDecorator, getFieldsValue } = form;

    return (
      <div>
        <div className="tableListForm">
          <Row style={{ marginBottom: '16px' }}>
            <Col span={8} style={{ display: 'flex' }}>
              <BackBtn />
              {accountInfo.isHatcherMng || accountInfo.isIncubatorMng ? (
                <Button onClick={() => this.handleVisible(true)}>作废发票</Button>
              ) : null}
              <Link
                style={{ paddingLeft: '8px' }}
                to={`/incubator/one/${this.props.params.uuid}/invoice/add`}
              >
                <Button>开票</Button>
              </Link>
              <Select
                defaultValue="all"
                onChange={this.changeHidden}
                style={{
                  width: '220px',
                  display: 'inline',
                  marginLeft: '15px',
                }}
              >
                <Select.Option key="all">全部</Select.Option>
                <Select.Option key="hiddenInvoice">可开发票金额不为0的数据</Select.Option>
                <Select.Option key="hiddenReceipt">可开收据金额不为0的数据</Select.Option>
                <Select.Option key="hiddenBoth">两项都不为0的数据</Select.Option>
              </Select>
            </Col>

            <Col span={16} style={{ textAlign: 'right' }}>
              <Form style={{ textAlign: 'right' }} layout="inline">
                <Form.Item>
                  {getFieldDecorator('condition')(
                    <Input style={{ marginLeft: '8px' }} placeholder="请输入关键字" />,
                  )}
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    style={{ marginLeft: '8px' }}
                    onClick={() => {
                      this.onSearch(getFieldsValue());
                    }}
                    loading={loading}
                  >
                    搜索
                  </Button>
                  <Button style={{ marginLeft: '8px' }} onClick={this.onReset}>
                    重置
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
        <TableCustomStatic
          list={showList}
          pagination={{
            current: 1,
            pageSize: 1000,
            total: 1000,
          }}
          loading={loading}
          {...this.props}
          handleTableChange={this.handleTableChange}
        />
        {visible ? (
          <ModalInvalid
            onCancel={this.handleVisible}
            {...this.props}
            invalidInvoice={this.invalidInvoice}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
  data: state.invoice_todo_list.dataSource,
  loading: state.invoice_todo_list.loading,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/PageCustom.js